export enum FileUploadMode {
  Dropzone = 'dropzone',
  FileManager = 'filemanager',
}

export enum FileStatus {
  Pending = 'pending',
  Success = 'success',
  Error = 'error',
  Uploading = 'uploading',
  Uploaded = 'uploaded',
  Reading = 'reading',
}
export interface FileItem {
  id: string;
  file: File;
  selected: boolean;
  status: FileStatus;
  downloadUrl?: string;
  errorMessage?: string;
  progress: number;
  isSensitive?: boolean;
  uploadUrl?: string;
}

export interface PreviewableFile {
  name: string;
  fileUrl: string;
  id: string;
}
